// Sprint 35 item 1: the special guest with a mini-game. Pure and browser-safe: the engine decides with it, /verify recomputes with it.
// One guaranteed guest per player per shift (the shift seed picks the door and the animal), sometimes a second (a natural bull or
// bear knock in the plain look or as Mr Holden), never three. Lit-look bulls, gold and red knocks have no game yet and take no part.
import { GUEST } from './balance.js';
import { GAME_IDS } from './registry.js';

export const FREE_BLOCK = 5; // the free room has no shift: each block of five doorkeeper doors counts as one
export const guestLabel = pub => `guest:${pub}`;
export const kindLabel = pub => `guestkind:${pub}`;
export const freeGuestLabel = (pub, block) => `guest:free:${pub}:${block}`;
export const freeKindLabel = (pub, block) => `guestkind:free:${pub}:${block}`;

// The door among the player's doorkeeper doors (night: 2 to 4, never the warm-up, never the last door). A newcomer's first free-room
// block puts it on door 3 to 5, so the first minute's two doors and the door after never hold a game.
export function pickDoor(unit, { first = false } = {}) {
  const lo = first ? 3 : GUEST.doors.min, hi = first ? FREE_BLOCK : GUEST.doors.max;
  return lo + Math.min(hi - lo, Math.floor(unit * (hi - lo + 1)));
}

// bull or bear at the stated weights (exactly 50/50, or rule 55c breaks at the door itself), among games that are built.
export function pickKind(unit) {
  const ids = GAME_IDS.filter(id => GUEST.weights[id] > 0);
  const total = ids.reduce((a, id) => a + GUEST.weights[id], 0);
  let edge = 0;
  for (const id of ids) if (unit < (edge += GUEST.weights[id] / total)) return id;
  return ids.at(-1);
}

// The game a knock plays (sprint 36): a bull or a bear in the plain look plays its own; a bear in Mr Holden's look plays his (a look whose
// game is built may be worn by a guest, picked or natural); a bull look has no game yet; gold and red take none. pickKind never draws 'holden':
// he is a look of the bear, not a third animal, so the 50/50 of the guest's animal holds.
export const gameOfKnock = (special, look) => (look ? (special === 'bear' && look === 'holden' ? 'holden' : null) : special === 'bull' || special === 'bear' ? special : null);

// Does a natural roll have a game? The plain look of a bull or a bear (lit: it wears a look that has none).
export const hasGame = (special, lit) => GAME_IDS.includes(special) && !lit;

// One door. n: this doorkeeper door's number; d: the picked door; entries: the guests already recorded for this player this shift
// (or free-room block); natural: what the numbered roll made it; lit: it wears a lit look; kind: the picked animal.
// Returns { how: 'pick' | 'natural' | 'capped' | null, special? }. 'capped' means a plain knock: special null.
export function decideGuest({ n, d, entries = [], natural = null, lit = false, kind, cap = GUEST.maxPerShift }) {
  const pickDone = entries.some(e => e.how === 'pick');
  if (!pickDone && n >= d) return { how: 'pick', special: kind };
  if (!hasGame(natural, lit)) return { how: null };
  const counted = entries.filter(e => e.how !== 'capped').length + (!pickDone && n < d ? 1 : 0); // a pick still to come keeps its place
  return counted < cap ? { how: 'natural', special: natural } : { how: 'capped', special: null };
}
